import request from '@/utils/request'

export default {
    areaList: function () {
        return request({
            url: 'constant/area',
            method: 'post',
        });
    },
    weChatShareConfig: function (url) {
        return request({
            url: 'constant/weChatShareConfig',
            method: 'post',
            params: {url: url}
        });
    },
}
